module.exports = __webpack_public_path__ + "static/media/trial_expired.68551422.png";